import DomainSelect from './DomainSelect';
import TicketTypeSelect from './TicketTypeSelect';
import ProductTypeSelect from './ProductTypeSelect';
import SupplierSelect from './SupplierSelect';
import ContactSelect from './ContactSelect';
import CriticitySelect from './CriticitySelect';
import PrioritySelect from './PrioritySelect';

export {
  DomainSelect,
  TicketTypeSelect,
  ProductTypeSelect,
  SupplierSelect,
  ContactSelect,
  CriticitySelect,
  PrioritySelect,
};
